/* eslint-disable import/no-unresolved */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PrinterType {
  name: string;
  ipAddress: string;
  port: string;
}
export interface PrinterKOTType extends PrinterType {
  area: string;
}

interface PrinterState {
  default: PrinterType;
  reciept: PrinterType;
  kot: PrinterKOTType[];
  currentName: string;
  currentKOTIP: string;
}

const initialState: PrinterState = {
  currentName: '',
  currentKOTIP: '',
  default: {
    name: 'Default Printer',
    ipAddress: 'None',
    port: 'None',
  },
  reciept: {
    name: 'Receipt Printer',
    ipAddress: 'None',
    port: 'None',
  },
  kot: [],
};
const printerSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    updateDefaultPrinter: (
      state: PrinterState,
      { payload }: PayloadAction<PrinterType>,
    ) => {
      state.default = payload;
    },

    updateRecieptPrinter: (
      state: PrinterState,
      { payload }: PayloadAction<PrinterType>,
    ) => {
      state.reciept = payload;
    },
    updateKOTPrinter: (
      state: PrinterState,
      { payload }: PayloadAction<PrinterKOTType>,
    ) => {
      state.kot.push(payload);
    },
    removeKOTPrinter: (
      state: PrinterState,
      { payload }: PayloadAction<string>,
    ) => {
      const kOTPrinterId = payload;
      const exisitingItem = state.kot.find(
        (item) => item.ipAddress === kOTPrinterId,
      );
      if (exisitingItem) {
        state.kot = state.kot.filter((item) => item.ipAddress !== kOTPrinterId);
      }
    },
    updateCurrentName: (
      state: PrinterState,
      { payload }: PayloadAction<string>,
    ) => {
      state.currentName = payload;
    },
    updateKOTIP: (state: PrinterState, { payload }: PayloadAction<string>) => {
      state.currentKOTIP = payload;
    },
  },
});

export const {
  updateDefaultPrinter,
  updateRecieptPrinter,
  updateCurrentName,
  updateKOTPrinter,
  removeKOTPrinter,
  updateKOTIP,
} = printerSlice.actions;

export default printerSlice.reducer;
